import { isSuperuser } from 'Services/common/Features/User/userSlice'
import { FaultReportList } from 'Services/SalesManagement/Features/FaultReport/Components/FaultReportList'
import {
  FaultReportType,
  fetchFaultReports
} from 'Services/SalesManagement/Features/FaultReport/faultReportSlice'
import { ShortcutList } from 'Services/SalesManagement/Features/Shortcut/Components/ShortcutList'
import { fetchShortcuts } from 'Services/SalesManagement/Features/Shortcut/shortcutSlice'
import useTypedSelector, { useAppDispatch } from 'Store'
import { Box, Grid, LinearProgress } from '@mui/material'
import { useEffect } from 'react'
import { t } from 'ttag'

export default function HomePage() {
  const dispatch = useAppDispatch()

  const {
    unPlannedFaultReports,
    plannedFaultReports,
    loading: faultReportLoading
  } = useTypedSelector(state => state.faultReport)
  const { shortcuts, loading: shortcutLoading } = useTypedSelector(state => state.shortcut)

  const user = useTypedSelector(state => state.user.user)

  useEffect(() => {
    dispatch(fetchShortcuts())
    dispatch(fetchFaultReports())
  }, [dispatch])

  const isLoading = faultReportLoading === 'pending' || shortcutLoading === 'pending'

  return (
    <Box>
      {isLoading ? (
        <LinearProgress />
      ) : (
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, lg: 4 }}>
            <FaultReportList
              faultReports={unPlannedFaultReports}
              isSuperuser={isSuperuser(user)}
              faultReportType={FaultReportType.unplanned}
              title={t`Current incidents`}
              noEntriesText={t`No current incidents`}
            />
          </Grid>
          <Grid size={{ xs: 12, lg: 4 }}>
            <FaultReportList
              faultReports={plannedFaultReports}
              isSuperuser={isSuperuser(user)}
              faultReportType={FaultReportType.planned}
              title={t`Planned service breaks`}
              noEntriesText={t`No planned service breaks`}
            />
          </Grid>
          <Grid size={{ xs: 12, lg: 4 }}>
            <ShortcutList shortcuts={shortcuts} isSuperuser={isSuperuser(user)} />
          </Grid>
        </Grid>
      )}
    </Box>
  )
}
